import React from "react";
import { Link } from "react-router-dom";
import logoImg from "images/logo.png";
import logoLightImg from "images/logo-light.png";
import lokalai_dark from "images/logos/lokalai/logo_dark.png";
import lokalai_w from "images/logos/lokalai/logo_b.png";
import LogoSvgLight from "./LogoSvgLight";
import LogoSvg from "./LogoSvg";

export interface LogoProps {
  img?: string;
  imgLight?: string;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({
  // img = logoImg,
  // imgLight = logoLightImg,
  img = lokalai_dark,
  imgLight = lokalai_w,
  className = "w-60",
}) => {
  return (
    <Link
      to="/"
      className={`ttnc-logo inline-block text-primary-6000 focus:outline-none focus:ring-0 ${className}`}
    >
      {img ? (
        <img
          className={`block h-10 ${imgLight ? "dark:hidden" : ""}`}
          src={imgLight}
          alt="Logo"
        />
      ) : (
        "Logo Here"
      )}
      {imgLight && (
        <img className="hidden h-10 dark:block" src={img} alt="Logo-Light" />
      )}
    </Link>
  );
};

export default Logo;
